import { c as _c } from "react/compiler-runtime";
import { useNumberFormatter } from "@opensea/i18n";
import { ImageStack, Toast, ToastAvatar, ToastContent, ToastDescription, ToastErrorIcon, ToastSide, ToastSuccessIcon, ToastTitle } from "@opensea/ui-kit";
import { Offer } from "@opensea/ui-kit/icons";
import { useTranslations } from "use-intl";
import { Avatar } from "../../../components/Avatar";
import { useRenderImage } from "../../../providers/RenderImageProvider";
export function CreateOfferToast(t0) {
  const $ = _c(18);
  const {
    imageUrls,
    price,
    success,
    status
  } = t0;
  const t = useTranslations("wallet.CreateOfferToast");
  const {
    renderImage
  } = useRenderImage();
  const format = useNumberFormatter();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Avatar.Badge><Offer size={12} /></Avatar.Badge>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const badge = t1;
  let t2;
  if ($[1] !== imageUrls || $[2] !== renderImage) {
    t2 = imageUrls.length === 1 ? <ToastAvatar badge={badge} renderImage={renderImage} src={imageUrls[0] || ""} /> : <ImageStack overrides={{
      Avatar: {
        position: {
          center: {
            className: "rounded",
            renderImage,
            badge
          },
          right: {
            className: "rounded"
          }
        }
      }
    }} size={44} srcs={imageUrls.slice(0, 2).map(_temp)} />;
    $[1] = imageUrls;
    $[2] = renderImage;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== format || $[5] !== imageUrls.length || $[6] !== price || $[7] !== status || $[8] !== success || $[9] !== t) {
    t3 = <ToastContent>{status === "SUCCESS" || success ? <><ToastTitle>{t("title", {
            count: imageUrls.length
          })}</ToastTitle>{imageUrls.length === 1 ? <ToastDescription>{format(price.unit, {
            display: "full",
            suffix: price.symbol
          })}</ToastDescription> : null}</> : <ToastTitle>{t("failedTitle")}</ToastTitle>}</ToastContent>;
    $[4] = format;
    $[5] = imageUrls.length;
    $[6] = price;
    $[7] = status;
    $[8] = success;
    $[9] = t;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== status || $[12] !== success) {
    t4 = <ToastSide>{status === "SUCCESS" || success ? <ToastSuccessIcon /> : <ToastErrorIcon />}</ToastSide>;
    $[11] = status;
    $[12] = success;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t2 || $[15] !== t3 || $[16] !== t4) {
    t5 = <Toast>{t2}{t3}{t4}</Toast>;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}
function _temp(imageUrl) {
  return imageUrl || "";
}